// extracted by mini-css-extract-plugin
export default {"SecondaryNavbar":"SecondaryNavbar_SecondaryNavbar__+WMS1"};